module.exports = __webpack_public_path__ + "static/media/uy.6afe5efa.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/uy.svg
// module id = 796
// module chunks = 0